/* eslint-disable @typescript-eslint/no-unused-vars */
import { FC } from 'react'

import { CountdownEvent } from '@/components/CountdownEvent/CountdownEvent'
import {
  ChannelType,
  EventType,
  MediaContentType,
} from '@/types/servicesTypes/configTypes'

import { DebugInfo } from './styles'

export type DebugInfoProps = {
  eventChannel?: Nullable<ChannelType>
  event?: Nullable<EventType>
  mediaVideo?: MediaContentType
}

export const ChannelVideoDebugInfo: FC<DebugInfoProps> = ({
  eventChannel,
  event,
  mediaVideo,
}) => {
  const currentEvent = (!event?.isFutureChannelEvent && event) || null
  const futureEvent = (event?.isFutureChannelEvent && event) || null

  const isAccessible =
    currentEvent?.userRights?.canAccess ?? eventChannel?.userRights?.canAccess

  const showCountdownEvent =
    eventChannel?.watchable &&
    !isAccessible &&
    !currentEvent &&
    futureEvent?.userRights?.canAccess
  return null
  // if (showCountdownEvent) {
  //   return (
  //     <DebugInfo>
  //       <CountdownEvent startTime={futureEvent.startTime} />
  //     </DebugInfo>
  //   )
  // } else {
  //   return null
  // }

  // if (!eventChannel && !event && mediaVideo) {
  //   return (
  //     <DebugInfo>
  //       contentType: <span>{String(mediaVideo?.contentType)}</span>
  //       videoId: <span>{String(mediaVideo?.id)}</span>
  //     </DebugInfo>
  //   )
  // }

  // return (
  //   <DebugInfo>
  //     channelId: <span>{String(eventChannel?.id)}</span>
  //     channelWatchable: <span>{String(eventChannel?.watchable)}</span>
  //     isAccessible: <span>{String(isAccessible)}</span>
  //     isChannelAccessible:{' '}
  //     <span>{String(eventChannel?.userRights?.canAccess)}</span>
  //     hasCurrentEvent: <span>{String(!!currentEvent)}</span>
  //     isCurrentEventAccessible:
  //     <span>{String(currentEvent?.userRights?.canAccess)}</span>
  //     hasAccessibleFutureEvent:
  //     <span>{String(!!futureEvent?.userRights?.canAccess)}</span>
  //     {showCountdownEvent && (
  //       <CountdownEvent startTime={futureEvent.startTime} />
  //     )}
  //   </DebugInfo>
  // )
}
